import { ampli } from '@/ampli';
import type { TransactionFailedProperties } from '@/ampli';

import type { AdvancedOrderProvider } from '@/constants/advancedOrder';
import { NETWORK_NAME_PER_CHAIN_ID } from '@/constants/chain';

type TokenInfo = {
  address: string;
  chainId: number;
  symbol?: string;
};

type TrackTransactionFailedArgs = {
  sellToken: TokenInfo;
  buyToken: TokenInfo;
  failureStage: TransactionFailedProperties['failure_stage'];
  failureReason: TransactionFailedProperties['failure_reason'];
  swapOrderType: TransactionFailedProperties['swap_order_type'];
  swapExecutionType?: TransactionFailedProperties['swap_execution_type'];
  swapTxHash?: string;
  revertReason?: string;
  submissionReason?: string;
  recipientAddress?: string;
  matchaReferrer?: string;
  swapSlippageBps?: number;
  swapSlippageMode?: TransactionFailedProperties['swap_slippage_mode'];
  swapProvider?: TransactionFailedProperties['swap_provider'];
  swapZid?: string;
  bridgeProvider?: string;
  advancedOrderProvider?: AdvancedOrderProvider;
  uiLocation?: string;
};

export const trackTransactionFailed = ({
  sellToken,
  buyToken,
  failureStage,
  failureReason,
  swapOrderType,
  swapExecutionType,
  swapTxHash,
  revertReason,
  submissionReason,
  recipientAddress,
  matchaReferrer,
  swapSlippageBps,
  swapSlippageMode,
  swapProvider,
  swapZid,
  bridgeProvider,
  advancedOrderProvider,
  uiLocation,
}: TrackTransactionFailedArgs) => {
  ampli.transactionFailed({
    bridge_provider: bridgeProvider,
    buy_token_address: buyToken.address,
    buy_token_chain_id: buyToken.chainId,
    buy_token_chain_name: NETWORK_NAME_PER_CHAIN_ID[buyToken.chainId] || '',
    buy_token_symbol: buyToken.symbol,
    failure_reason: failureReason,
    failure_stage: failureStage,
    limit_order_provider: advancedOrderProvider,
    matcha_referrer: matchaReferrer,
    recipient_address: recipientAddress,
    revert_reason: revertReason,
    submission_reason: submissionReason,
    sell_token_address: sellToken.address,
    sell_token_chain_id: sellToken.chainId,
    sell_token_chain_name: NETWORK_NAME_PER_CHAIN_ID[sellToken.chainId] || '',
    sell_token_symbol: sellToken.symbol,
    swap_execution_type: swapExecutionType,
    swap_order_type: swapOrderType,
    swap_slippage_bps: swapSlippageBps,
    swap_slippage_mode: swapSlippageMode,
    swap_provider: swapProvider,
    swap_tx_hash: swapTxHash,
    swap_zid: swapZid,
    ui_location: uiLocation,
  });
};
